/**
 * useEdgeStream Hook
 *
 * Access EdgeStream instance from React context
 */

import React from 'react';
import type { IEdgeStream } from '../../types';
import { EdgeStreamContext } from '../EdgeStreamContext';

export function useEdgeStream(): IEdgeStream {
  const context = React.useContext(EdgeStreamContext);
  if (!context) {
    throw new Error('useEdgeStream must be used within EdgeStreamProvider');
  }
  return context.stream;
}
